
<template>
  <div class="box">
    <div class="image">
      <img src="../icons/profile.svg" />
    </div>
    <div class="ml-4">
      <p class="mt-2 mb-0">
        <b>{{ name }}</b>
      </p>
      <p>{{ phone }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "phone"],
};
</script>
<style scoped>
.box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: rgb(240, 233, 233);
  padding: 0 1rem;
}
</style>